import React, { AnchorHTMLAttributes } from 'react';
import { PrimaryAnchor, PrimaryLink, SecondaryAnchor, SecondaryLink } from './link.styles';

interface ILinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary';
  external?: boolean;
}

export const CustomLink = ({ children, variant, external = false, ...props }: ILinkProps) => {
  if (variant === 'secondary') {
    if (external) {
      return <SecondaryAnchor {...props}>{children}</SecondaryAnchor>;
    }
    return (
      <SecondaryLink {...props as any}>
        {children}
      </SecondaryLink>
    );
  }
  if (external) {
    return <PrimaryAnchor {...props}>{children}</PrimaryAnchor>;
  }
  return (
    <PrimaryLink {...props as any}>
      {children}
    </PrimaryLink>
  );
};
